import { render, staticRenderFns } from "./worldmap.vue?vue&type=template&id=911ac3ba"
import script from "./worldmap.vue?vue&type=script&lang=js"
export * from "./worldmap.vue?vue&type=script&lang=js"
import style0 from "./worldmap.vue?vue&type=style&index=0&id=911ac3ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_1d815c3a82e414dc02ba46af5dbd33b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports